import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Table, Modal, InputNumber } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultSupportNeed,
  addSupportNeed,
  getResultOptionSupportNeed,
  deleteSupportNeed,
  updateSupportNeed,
  updateStatusSupportNeed,
  sendMailSupportNeed,
} from 'api/Project/supportneed'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  // console.log(props)
  const {
    idEditPRJ,
    visibleDelete,
    setVisibleDelete,
    dataEdit,
    getSupportNeed,
    getLogList,
    pageTaskInboxDetail,
  } = props

  const language = getCookie('lang')
  const word = lang[language]

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  // const [form] = Form.useForm()

  const Deleteremark = () => {
    const dataArray = {}
    try {
      deleteSupportNeed({
        project_id: parseInt(idEditPRJ),
        params: dataArray,
        token: token,
        supportneed_id: dataEdit.id,
      }).then((response) => {
        if (response.status === 200) {
          if (pageTaskInboxDetail === 'taskinboxdetail') {
            getLogList()
          }

          getSupportNeed()
          setVisibleDelete(false)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Modal
      maskClosable={false}
      className="DeleteModal"
      visible={visibleDelete}
      okText={'Delete'}
      onOk={() => Deleteremark()}
      onCancel={() => setVisibleDelete(false)}
    >
      <CloseCircleOutlined className="CloseCircleOutlined" />
      <h2>{word['addtask_supportneed_title_modaldelete_title']}</h2>
      <h4>{word['addtask_supportneed_title_modaldelete_des']}</h4>
    </Modal>
  )
}
export default AddTaskKPIFinance
